import { createContext, useContext } from "react"

const STORAGE_KEY = "debug:customTheme"

export type DebugThemeContextValue = {
  customTheme: boolean
  setCustomTheme: (enabled: boolean) => void
}

export const DebugThemeContext = createContext<DebugThemeContextValue>({
  customTheme: true,
  setCustomTheme: () => {},
})

export const useDebugTheme = () => useContext(DebugThemeContext)

/** Read the initial value from localStorage (true = custom Mobilus theme) */
export const getInitialCustomTheme = (): boolean => {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored !== "false" // default to true (custom theme on)
}

/** Persist the preference */
export const persistCustomTheme = (enabled: boolean) => {
  localStorage.setItem(STORAGE_KEY, String(enabled))
}
